//import im from '../images/images1.jpg';
import dakshglobal from '../images/dakshglobal.jpeg';
import comingsoon from '../images/comingsoon.jpg';
import logo from '../images/logo_dakshGlobal.png';
export const ImageUrls = [
    comingsoon,
    dakshglobal
];
export const Logo = logo;